import type { SwiFormState } from '../components/SwiConfigSection';

/** Remove tags HTML e normaliza espaços do texto SWI. */
export function stripSwiHtml(html: string): string {
  return html
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Indica se a rotina possui padrão SWI substantivo (texto, POP ou checklist). */
export function hasSwiPatternContent(swi: SwiFormState): boolean {
  if (swi.swi_doc_url) return true;
  if (swi.swi_checklist.some((item) => item.text.trim())) return true;
  return stripSwiHtml(swi.swi_text).length > 0;
}
